import { render } from "./ModalHistory.vue?vue&type=template&id=3f0bdaac&scoped=true"
import script from "./ModalHistory.vue?vue&type=script&lang=js"
export * from "./ModalHistory.vue?vue&type=script&lang=js"

import "./ModalHistory.vue?vue&type=style&index=0&id=3f0bdaac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0bdaac"]])

export default __exports__